import { CUSTOMER_SOURCES, type CustomerSource } from '@vy/types';
import { isNullOrUndefined } from '@vy/utils';

const CUSTOMER_SOURCE_LABELS: Partial<Record<CustomerSource, string>> = {
  [CUSTOMER_SOURCES.VayuEventsApi]: 'Vayu Events API',
};

export function formatCustomerSource(source?: CustomerSource | null): string {
  if (isNullOrUndefined(source)) {
    return 'Vayu';
  }

  return CUSTOMER_SOURCE_LABELS[source] ?? source;
}
